import script from "./areas.vue?vue&type=script&setup=true&lang=js"
export * from "./areas.vue?vue&type=script&setup=true&lang=js"

import "./areas.vue?vue&type=style&index=0&id=0e8e4423&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8e4423"]])

export default __exports__